const getters = {
  token: state => state.admin.token,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js